/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { type Dispatch, useEffect, useMemo, useRef } from 'react';
import { usePrefersReducedMotion } from './preferences/usePreferredTheme';
import { createWindowLayoutDispatcher } from './window-layout-transitions';
import type { DesktopWindowAction } from './windowSystem';

export function useWindowLayoutTransitions(dispatch: Dispatch<DesktopWindowAction>) {
  const reducedMotion = usePrefersReducedMotion();
  const reducedMotionRef = useRef(reducedMotion);
  reducedMotionRef.current = reducedMotion;
  const controller = useMemo(
    () => createWindowLayoutDispatcher(dispatch, () => reducedMotionRef.current),
    [dispatch],
  );
  useEffect(() => () => controller.dispose(), [controller]);
  return controller.dispatch;
}
